import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/app/loading.tsx");
